/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";

/*REDUX*/
import { createLayer } from "../../App/actions/layerNewActions";
import {
  setEditGeometry,
  set_value_layer,
} from "../../App/actions/layerActions";
import { post_activities } from "../../App/actions/activities";

/*PICTURE*/

/*FUNCTION*/
import { select_field_from_default_props } from "../../App/validation/generateGeoJson";

/*DATA*/
import dict from "../../Data/dict.json";
import { snackbar } from "../../App/actions/snackbarActions";

/*CONST*/

const CreateLayer = ({
  auth,
  project,
  layer,
  createLayer,
  post_activities,
}) => {
  const [state, setState] = useState({
    name: "",
    description: "",
    type: "Point",
    user_id: auth.user._id,
    folder: "",
    modal_warn: false,
  });

  const dispatch = useDispatch();

  const { name, description, type, folder, modal_warn, user_id } = state;

  useEffect(() => {
    const { _id } = auth.user;
    setState((prevState) => ({ ...prevState, user_id: _id }));
  }, [auth.user]);

  const toggle_warn = () => {
    setState((prevState) => ({
      ...prevState,
      modal_warn: !prevState.modal_warn,
    }));
  };

  const handleChange = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { geo_project } = project;
    const { geo_layer_list } = layer;
    const any_same_name = geo_layer_list.some(
      (e) => e?.geo_layer?.name === name,
    );

    if (!name) {
      toggle_warn();
    } else {
      if (any_same_name) {
        dispatch(
          snackbar({
            is_open: true,
            status: "warning",
            message:
              dict["Layer name must not be the same in one project"][language],
          }),
        );
        return;
      }

      const fields = select_field_from_default_props(type);

      //khusus_danamas

      const body = {
        name,
        description,
        type,
        folder,
        user_id,
        geo_project_id: geo_project._id,
        fields: [],
        properties: fields,
        status: "digitasi",
        architecture: "v2",
      };
      createLayer(body);

      post_activities({
        action: "create_layer",
      });

      setState((prevState) => ({
        ...prevState,
        name: "",
        description: "",
        type: "Point",
        user_id: auth.user._id,
        folder: "",
      }));
    }
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const { geo_project, loadingDetail } = project;
  const { loadingProcess, itemLoading } = layer;

  //content
  const modal_warn_content = modal_warn && (
    <Modal modalSize="small" isOpen={modal_warn} onClose={toggle_warn}>
      <div className="box-body" id="box-body">
        {dict?.["Please fill in the layer name first"]?.[language]}
      </div>
    </Modal>
  );

  const { folders } = geo_project;
  let folders_state = [];
  if (!loadingDetail && geo_project.folders) {
    folders_state = folders.slice();
    folders_state.unshift({
      name: dict?.["Outside folders"]?.[language],
      _id: "",
    });
  }

  const layer_type_array = ["Point", "LineString", "Polygon"];
  let button_content;
  if (loadingProcess && itemLoading === "createLayer") {
    button_content = (
      <div type="submit" className="button background_white">
        {dict?.["Create Layer"]?.[language]}...
      </div>
    );
  } else {
    button_content = (
      <button
        type="submit"
        disabled={!name}
        className={`button ${name ? "background_black" : "background_grey"}`}
        style={{
          color: "white",
        }}
        data-mapid="clickCreate"
      >
        {dict?.["Create Layer"]?.[language]}
      </button>
    );
  }

  const content = (
    <main>
      <form
        className="flex flex_col"
        style={{ gap: "10px" }}
        onSubmit={handleSubmit}
      >
        <input
          type="text"
          placeholder={dict["Layer name"][language]}
          autoComplete="off"
          className="input_new"
          style={{ border: "1px solid #ABABAB4D" }}
          name="name"
          value={name}
          onChange={handleChange}
          data-mapid="inputLayerName"
        />
        <textarea
          type="text"
          style={{ border: "1px solid #ABABAB4D" }}
          placeholder={dict["Layer description"][language]}
          autoComplete="off"
          className="input_new"
          name="description"
          value={description}
          onChange={handleChange}
          data-mapid="inputLayerDeskription"
        />
        <select
          style={{
            marginBottom: 0,
            marginTop: 0,
            border: "1px solid #ABABAB4D",
          }}
          id="layer_type"
          name="type"
          value={type}
          className="input_new"
          onChange={handleChange}
          data-mapid="selectType"
        >
          {layer_type_array.map((type, idx) => {
            return (
              <option key={idx} value={type}>
                {type}
              </option>
            );
          })}
        </select>
        <select
          id="folder"
          name="folder"
          value={folder}
          className="input_new"
          onChange={handleChange}
          data-mapid="selectFolder"
          style={{
            marginBottom: 0,
            marginTop: 0,
            border: "1px solid #ABABAB4D",
          }}
        >
          {folders_state.map(({ _id, name }, idx) => {
            return (
              <option key={idx} value={_id}>
                {name}
              </option>
            );
          })}
        </select>
        <div className="margin_top">{button_content}</div>
      </form>
    </main>
  );

  return (
    <main>
      {content}
      {modal_warn_content}
    </main>
  );
};

const mapStateToProps = (state) => ({
  project: state.project,
  layer: state.layer,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  createLayer,
  setEditGeometry,
  set_value_layer,
  post_activities,
})(CreateLayer);
